import {
  allHandlesConnected,
  notOnForkedBranch
} from 'Automations/nodeDefinitions/validation/nodeValidators'

export const handlesConnected = allHandlesConnected({
  handleTypes: ['target'],
  title: 'Disconnected node',
  message: 'All handles must be connected'
})

export const notForked = notOnForkedBranch({
  title: 'Invalid end node',
  message: 'An end node cannot be placed on a forked branch'
})
